<template>
  <modal
    v-if="visible"
    :visible="visible"
    @click-outside-modal="$emit('close')"
  >
    <div class="container-eligibility flex justify-center px-4">
      <div class="relative flex flex-col items-start rounded bg-white p-6">
        <img
          class="absolute right-4 top-4 h-4 w-4 cursor-pointer"
          src="@/assets/close-icon.svg"
          alt="cose icon"
          @click="$emit('close')"
        />
        <h3 class="mb-4 text-2xl text-dark-blue">Are you sure?</h3>
        <p class="mb-4 text-left text-1md text-body-color">
          You can only use this option if you belong to an Intrastate,
          Intra-Canada, Intra-Mexico, or Intra-Europe carrier who does not have
          a DOT or MC number.
        </p>
        <div class="flex w-full flex-col gap-3">
          <button-main
            class="text-1md"
            @click="() => $emit('close')"
          >
            Go Back
          </button-main>
          <button-main
            class="text-1md"
            variant="secondary"
            @click="() => $emit('continue')"
          >
            My carrier doesn't have a DOT/MC
          </button-main>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/modals/Modal.vue';
import ButtonMain from '@/components/Button.vue';

export default {
  name: 'EligibilityConfirmationModal',
  components: {
    Modal,
    ButtonMain,
  },
  props: {
    visible: Boolean,
  },
  emits: ['close'],
};
</script>

<style scoped>
.container-eligibility {
  width: 450px;
}

@media screen and (max-width: 449px) {
  .container-eligibility {
    width: 340px;
  }
}
</style>
